import React, { Fragment, useEffect, useRef } from 'react';

var callbacks = [];

declare const window: any;
declare const FB: any;

const addScript = (src, cb) => {
  if (callbacks.length === 0) {
    callbacks.push(cb)
    var s = document.createElement('script')
    s.setAttribute('src', src)
    s.setAttribute('async', "1")
    s.setAttribute('defer', "1")
    s.setAttribute('crossorigin', "anonymous")
    s.onload = () => callbacks.forEach((cb) => cb())
    document.body.appendChild(s)
  }
  else {
    callbacks.push(cb)
  }
}

const Facebook = ({ url, type, show_text, width, height, kind }) => {
  const iframeRef = useRef<HTMLIFrameElement>(null);
  useEffect(() => {
    if (kind === 'iframe') {
      // Facebook plugin iframes post their rendered content height to the parent. Every post
      // is a different height, so rather than guess we listen for that message and size the
      // iframe to the post's actual height.
      const handleMessage = (e: MessageEvent) => {
        if (e.origin !== 'https://www.facebook.com' || !e.data) return;
        const el = iframeRef.current;
        if (!el || el.contentWindow !== e.source) return;
        try {
          const parts = String(e.data).split('&');
          const parsed = Number(parts[parts.length - 1].split('=')[1]);
          if (parsed > 0) el.style.height = `${parsed}px`;
        } catch (err) { /* ignore malformed messages */ }
      };
      window.addEventListener('message', handleMessage);
      return () => window.removeEventListener('message', handleMessage);
    }
    const renderFacebook = () => {
      window.FB.XFBML.parse();
    }
    if (!window.FB) {
      addScript("https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v11.0", renderFacebook)
    }
    else {
      renderFacebook();
    }
  }, []);

  // Facebook's own embed iframe (plugins/post.php|video.php) renders directly, the same
  // way YouTube/Instagram do. Only facebook.com/plugins/* URLs reach here (host-gated in
  // findEmbedType), so the src origin is trusted. Use a fixed attribute set rather than
  // spreading arbitrary pasted attributes.
  if (kind === 'iframe') {
    // Width comes from Facebook's plugin URL (its fixed content width per embed type). The
    // initial height is the embed's own height — from the query for video/reel, else the
    // fragment preserved by iFrameUrl for posts — then auto-corrected by the resize message
    // above. The fragment is stripped from the rendered src so Facebook gets a clean URL.
    let w: string | number = 500;
    let h: string | number = '';
    try {
      const u = new URL(url);
      const pw = u.searchParams.get('width'); if (pw) w = pw;
      const ph = u.searchParams.get('height'); if (ph) h = ph;
      const hashH = u.hash && u.hash.match(/h=(\d+)/); if (hashH) h = hashH[1];
    } catch (e) { /* keep defaults */ }
    if (!h) h = type === 'video' ? Math.round(Number(w) * 9 / 16) : 600;
    return (
      <iframe
        ref={iframeRef}
        src={url.split('#')[0]}
        width={w}
        height={h}
        style={{ border: 'none', overflow: 'hidden' }}
        scrolling="no"
        frameBorder="0"
        allowFullScreen={true}
        allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
      ></iframe>
    );
  }

  return (
    <Fragment>
      <div className="fb-post" data-href={url} data-width={width ? width : "500"}></div>
    </Fragment>
  );
}

export default Facebook;